const News = [
    {
        image:"",
        date:"28 January, 2020 ",
        admin:"By Admin",
        air:"Air Transport",
        heading:"Having over weight and depression can",
        read:"Read More",
    },
    {
        image:"",
        date:"28 January, 2020 ",
        admin:"By Admin",
        air:"Air Transport",
        heading:"Connection between post and link",
        read:"Read More",
    },
    {
        image:"",
        date:"28 January, 2020 ",
        admin:"By Admin",
        air:"Air Transport",
        heading:"Having over weight and depression can",
        read:"Read More",
    },
    {
        image:"",
        date:"28 January, 2020 ",
        admin:"By Admin",
        air:"Air Transport",
        heading:"Having over weight and depression can",
        read:"Read More",
    },
]

export default News;